import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-input-clear-button',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatButtonModule, MatIconModule],
  template: `
    @if (invisibleOnEmpty || control?.value) {
      <button
        [ngClass]="{ invisible: !control?.value }"
        tabindex="-1"
        (keydown.enter)="$event.preventDefault()"
        mat-icon-button
        aria-label="Clear"
        (click)="onClick()">
        <mat-icon>close</mat-icon>
      </button>
    }
    `,
  styles: [
    `
      :host {
        margin-right: -10px;
      }
    `,
  ],
})
export class InputClearButtonComponent {
  @Input() control: AbstractControl;
  @Input() invisibleOnEmpty = false;

  constructor() {}

  onClick() {
    this.control.reset();
    this.control.markAsDirty();
  }
}
